export default __webpack_public_path__ + "static/media/loading-skull-alp.d7293d44.gif";